var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.mode !== 'yandex-pay-success' ? _c('aside', {
    staticClass: "_profile-settings-column"
  }, [_c('h5', {
    staticClass: "_profile-column-title settings"
  }, [_vm._v("Настройки")]), _c('ul', {
    staticClass: "_profile-nav"
  }, [_vm._m(0), _vm._m(1), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.logout($event);
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/lk-menu-exit.svg"),
      "alt": "exit"
    }
  }), _c('span', [_vm._v(" Выйти из аккаунта")]), _c('img', {
    staticClass: "_profile-nav-arr",
    attrs: {
      "src": require("@/assets/img/lk-menu-arrow.svg"),
      "alt": "arrow"
    }
  })])])])]) : _vm._e();
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "/profile#change-password"
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/lk-menu-key.svg"),
      "alt": "key"
    }
  }), _c('span', [_vm._v("Изменить пароль")]), _c('img', {
    staticClass: "_profile-nav-arr",
    attrs: {
      "src": require("@/assets/img/lk-menu-arrow.svg"),
      "alt": "arrow"
    }
  })])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "/profile#email-control"
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/lk-menu-letter.svg"),
      "alt": "letter"
    }
  }), _c('span', [_vm._v("Управление e-mail")]), _c('img', {
    staticClass: "_profile-nav-arr",
    attrs: {
      "src": require("@/assets/img/lk-menu-arrow.svg"),
      "alt": "arrow"
    }
  })])]);
}]

export { render, staticRenderFns }